import { FinanceCircular } from '../types/catalog';

// Circular comercial oficial FCA Compañía Financiera (Stellantis) Nro. 017.26 — Promociones 0 km Jeep y Ram, octubre 2026.
// Cuotas calculadas con el coeficiente "Cuota 1 x $1.000 con IVA". No incluye seguro automotor.

const common = {
  lender: 'FCA Compañía Financiera',
  reference: 'Circular comercial Nro. 017.26 · Octubre 2026',
  validFrom: '2026-10-01',
  validUntil: '2026-10-31',
  managementFeePct: 18,
  notes: ['La cuota no incluye seguro automotor.', 'Sujeto a aprobación crediticia de FCA Compañía Financiera.'],
};

export const jeepCircular: FinanceCircular = {
  ...common,
  brandId: 'jeep',
  lines: [
    {
      id: 'jeep-tasa-fija-18',
      name: 'Campaña Jeep Tasa Fija',
      detail: 'Toda la gama',
      maxAmount: 18000000,
      models: 'all',
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 18, tna: 0, dealerContributionPct: 11, installmentPer1000: 56.22 },
        { term: 24, tna: 10.9, dealerContributionPct: 11, installmentPer1000: 48.95 },
        { term: 36, tna: 20.9, dealerContributionPct: 11, installmentPer1000: 41.58 },
      ],
    },
    {
      id: 'jeep-tasa-fija-24',
      name: 'Campaña Jeep Tasa Fija',
      detail: 'Toda la gama',
      maxAmount: 24000000,
      models: 'all',
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 0, dealerContributionPct: 11, installmentPer1000: 84.33 },
        { term: 18, tna: 8.9, dealerContributionPct: 11, installmentPer1000: 61.76 },
        { term: 24, tna: 17.9, dealerContributionPct: 11, installmentPer1000: 53.48 },
        { term: 36, tna: 25.9, dealerContributionPct: 11, installmentPer1000: 45.05 },
      ],
    },
    {
      id: 'jeep-tasa-fija-28',
      name: 'Campaña Jeep Tasa Fija',
      detail: 'Renegade, Compass y Commander',
      maxAmount: 28000000,
      models: ['Renegade', 'Compass', 'Commander'],
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 0, dealerContributionPct: 12, installmentPer1000: 84.33 },
        { term: 18, tna: 0, dealerContributionPct: 12, installmentPer1000: 56.22 },
        { term: 24, tna: 9.9, dealerContributionPct: 12, installmentPer1000: 48.32 },
        { term: 36, tna: 19.9, dealerContributionPct: 12, installmentPer1000: 40.89 },
      ],
    },
    {
      id: 'jeep-compass-sport-28',
      name: 'Compass Sport Tasa 0%',
      detail: 'Exclusiva Jeep Compass Sport',
      maxAmount: 28000000,
      models: ['Compass Sport'],
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [{ term: 24, tna: 0, dealerContributionPct: 12, installmentPer1000: 42.17 }],
    },
    {
      id: 'jeep-uva-30',
      name: 'Promo UVA Jeep',
      detail: 'Toda la gama',
      maxAmount: 30000000,
      models: 'all',
      rateType: 'uva',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 0, dealerContributionPct: 6, installmentPer1000: 84.33 },
        { term: 18, tna: 0, dealerContributionPct: 10, installmentPer1000: 56.22 },
        { term: 24, tna: 0, dealerContributionPct: 10, installmentPer1000: 42.17 },
        { term: 36, tna: 5.9, dealerContributionPct: 10, installmentPer1000: 31.73 },
        { term: 48, tna: 9.9, dealerContributionPct: 10, installmentPer1000: 27.28 },
        { term: 60, tna: 12.9, dealerContributionPct: 10, installmentPer1000: 25.14 },
      ],
    },
  ],
};

export const ramCircular: FinanceCircular = {
  ...common,
  brandId: 'ram',
  lines: [
    {
      id: 'ram-tasa-fija-20',
      name: 'Campaña Ram Tasa Fija',
      detail: 'Toda la gama',
      maxAmount: 20000000,
      models: 'all',
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 0, dealerContributionPct: 12, installmentPer1000: 84.33 },
        { term: 18, tna: 11.9, dealerContributionPct: 12, installmentPer1000: 63.67 },
        { term: 24, tna: 19.9, dealerContributionPct: 12, installmentPer1000: 54.8 },
        { term: 36, tna: 26.9, dealerContributionPct: 12, installmentPer1000: 45.76 },
      ],
    },
    {
      id: 'ram-dakota-rampage-30',
      name: 'Dakota y Rampage',
      detail: 'Ram Dakota y Ram Rampage',
      maxAmount: 30000000,
      models: ['Dakota', 'Rampage'],
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 7.9, dealerContributionPct: 12, installmentPer1000: 89.31 },
        { term: 18, tna: 18.9, dealerContributionPct: 12, installmentPer1000: 68.18 },
        { term: 24, tna: 24.9, dealerContributionPct: 12, installmentPer1000: 58.14 },
        { term: 36, tna: 29.9, dealerContributionPct: 12, installmentPer1000: 47.9 },
      ],
    },
    {
      id: 'ram-dakota-rampage-40',
      name: 'Dakota y Rampage',
      detail: 'Ram Dakota y Ram Rampage',
      maxAmount: 40000000,
      models: ['Dakota', 'Rampage'],
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 11.9, dealerContributionPct: 12, installmentPer1000: 91.87 },
        { term: 18, tna: 20.9, dealerContributionPct: 12, installmentPer1000: 69.49 },
        { term: 24, tna: 25.9, dealerContributionPct: 12, installmentPer1000: 58.81 },
        { term: 36, tna: 31.9, dealerContributionPct: 12, installmentPer1000: 49.35 },
      ],
    },
  ],
};
